import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {empty, Observable, Subject, throwError} from 'rxjs';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../api/api.service';
import {AccessControlService} from '../access-control/access-control.service';
import {environment} from "../../../environments/environment";
import {LoginResponseModel} from "../../shared/models/login/login.model";
import {RefreshTokenModel} from "../../shared/models/login/refresh.model";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  refreshingAccessToken: boolean;

  accessTokenRefreshed: Subject<void> = new Subject();

  constructor(private _toastr: ToastrService,
              private _api: ApiService,
              private _accessControl: AccessControlService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 401) {
          this._toastr.error(error.error !== undefined ? error.error.message : '', 'Error', {
            timeOut: environment.TOASTER_TIMEOUT,
            positionClass: environment.TOASTER_POSITION
          });

        } else if (localStorage.getItem('TOKEN') && error.status === 401) {
          error.error.message === "Invalid token provided" ? this._accessControl.logout() : null;
          return this.refreshToken().pipe(
            switchMap((result: LoginResponseModel) => {
              request = request.clone({
                headers: request.headers.set('authorization', `Bearer ${result.access_token}`)
              })
              return next.handle(request);
            }),
            catchError(() => {
              return empty();
            })
          );
        } else if (!localStorage.getItem('TOKEN') && error.status === 401) {
          this._toastr.error(error.error.message, 'Error', {
            timeOut: environment.TOASTER_TIMEOUT,
            positionClass: environment.TOASTER_POSITION
          });

        }

        return throwError(error);
      })
    )
  }

  refreshToken(): Observable<LoginResponseModel> {
    if (this.refreshingAccessToken) {
      return new Observable<any>(observer => {
        this.accessTokenRefreshed.subscribe(() => {
          // this code will run when the access token has been refreshed
          observer.next(undefined);
          observer.complete();
        })
      })
    } else {
      this.refreshingAccessToken = true;
      let refreshTokenPayload: RefreshTokenModel = {
        grant_type: 'refresh_token',
        client_id: environment.CLIENT_ID,
        refresh_token: this._accessControl.getRefreshToken()===null?'invalidTokenorNullToken':this._accessControl.getRefreshToken()
       }
      return this._api.request('refreshToken', refreshTokenPayload).pipe(
        tap((result: LoginResponseModel) => {
          if(this._accessControl.setToken(result.access_token, result.refresh_token)){
            this.refreshingAccessToken = false;
            this.accessTokenRefreshed.next();
          }
        }, (error: any) => {
          console.error(error)
          this._accessControl.logout();
        })
      )
    }
  }
}
